import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { TaxratesFacade } from './+state';
import { TaxratesStateModule } from './+state/taxrate.state.module';
import { TaxrateService } from './services';

@NgModule({
  imports: [CommonModule, TaxratesStateModule],
})
export class DomainTaxratesModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainTaxratesModule,
      providers: [TaxrateService, TaxratesFacade],
    };
  }
}
